import { useTranslation } from 'react-i18next';
import { WifiOff } from 'lucide-react';

import { useIsServerReachable } from '@/shared/lib/network-status';

// A lost connection is a state, not an event: a persistent banner, not a toast
// per failed request (DESIGN.md §8). It goes away with the next answer.
export function OfflineBanner(): JSX.Element | null {
  const { t } = useTranslation();
  const isReachable = useIsServerReachable();
  if (isReachable) return null;
  return (
    <div
      role="status"
      className="flex items-center gap-2 border-b border-warning/40 bg-warning/15 px-4 py-2 text-sm text-foreground md:px-6"
    >
      <WifiOff className="size-4 shrink-0 text-warning-text" aria-hidden />
      <span>
        <span className="font-medium">{t('errors.offline.title')}</span> {t('errors.offline.hint')}
      </span>
    </div>
  );
}
